<template>
  <div>
    <risk-rating-definition />
    <hr />

    <!-- Rating definition eklendikten sonra buna gerek kalmadığı düşünüldüğü için kapatıldı -->
    <!-- <risk-decision /> -->
  </div>
</template>

<script>
import RiskDecision from "./organization-risk-decision";
import RiskRatingDefinition from "./organization-risk-rating-definiton";

export default {
  components: { RiskDecision, RiskRatingDefinition },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "./organization-risk-decision.scss";
</style>
